export enum MainBannerActionTypes {
  API_RESPONSE_SUCCESS = "@@mainBanner/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@mainBanner/API_RESPONSE_ERROR",

  CREATE_MAIN_BANNER = "@@mainBanner/CREATE_MAIN_BANNER",
  GET_MAIN_BANNER = "@@mainBanner/GET_MAIN_BANNER",
  UPDATE_MAIN_BANNER = "@@mainBanner/UPDATE_MAIN_BANNER",
  DELETE_MAIN_BANNER = "@@mainBanner/DELETE_MAIN_BANNER",
}
